import { render, staticRenderFns } from "./OriginCustomerCreateUpdate.vue?vue&type=template&id=2d484052&"
import script from "./OriginCustomerCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./OriginCustomerCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports